import { ChainId } from '@uniswap/sdk-core';
import { getChainInfoOrDefault } from 'constants/chainInfo';

import { useWeb3React } from 'hooks/useWeb3React';

import { PrimaryLargeText } from 'components/ui/Text';

import { TriangleIcon } from 'components/Icons';

export const ChainConnectivityWarning = () => {
  const { chainId } = useWeb3React();
  const info = getChainInfoOrDefault(chainId);
  const label = info?.label;

  return (
    <div className='fixed bottom-15 right-4 z-2 hidden max-w-87 flex-col gap-2 rounded-xl bg-blue-900 px-5 py-4 lg:flex'>
      <div className='flex flex-row items-center justify-start gap-2'>
        <TriangleIcon className='size-5 text-yellow' />

        <PrimaryLargeText>Network warning</PrimaryLargeText>
      </div>

      <div className='flex text-sm font-medium text-white'>
        {chainId === ChainId.MAINNET
          ? 'You may have lost your network connection.'
          : `${label} might be down right now, or you may have lost your network connection.`}{' '}
      </div>
    </div>
  );
};
